import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[numberOnly]',
})
export class NumberOnlyDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  public onInputChange(event: InputEvent): void {
    const initalValue: string = this.el.nativeElement.value;
    const newValue: string = initalValue.replace(/[^0-9]*/g, '');
    this.el.nativeElement.value = newValue;

    if (initalValue !== newValue) {
      event.stopPropagation();
    }
  }

  @HostListener('paste', ['$event'])
  public onPaste(event: ClipboardEvent): void {
    event.preventDefault();

    if (event.clipboardData) {
      const pastedText: string = event.clipboardData.getData('text/plain');
      const numbersOnly: string = pastedText.replace(/[^0-9]*/g, '');
      this.el.nativeElement.setRangeText(numbersOnly);
    }
  }
}
